<template>
  <header id="header" style="padding: 10px 0;background: #004a59;" class="fixed-top">
    <div class="container align-items-center">
      <nav class="navbar navbar-expand-lg navbar-light">
        <router-link to="/">
          <img style="max-height: 50px" src="assets/logo/logo_white.png" alt="winfin">
        </router-link>
<!--        <button class="navbar-toggler" type="button" data-toggle="collapse"-->
<!--                data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"-->
<!--                aria-expanded="false" aria-label="Toggle navigation">-->
<!--          <span class="navbar-toggler-icon"></span>-->
<!--        </button>-->
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto">
<!--            <li class="nav-item">-->
<!--              <a class="nav-link" href="javascript:" v-scroll-to="'#topup'">Recharge Now</a>-->
<!--            </li>-->
<!--            <li class="nav-item">-->
<!--              <a class="nav-link" href="javascript:" v-scroll-to="'#packages'">Recharge Offers</a>-->
<!--            </li>-->
<!--            <li class="nav-item">-->
<!--              <a class="nav-link" href="javascript:" v-scroll-to="'#how-to-recharge'">How To Recharge</a>-->
<!--            </li>-->
<!--            <li class="nav-item become-partner">-->
<!--              <a class="nav-link" href="javascript:" v-scroll-to="'#corporate'">Corporate Top-Up</a>-->
<!--            </li>-->
<!--            <li class="nav-item" v-if="!loginStatus ">-->
<!--              <a class="nav-link login" @click="openModal" target="_blank">Sign In / Sign Up</a>-->
<!--            </li>-->
<!--            <li class="nav-item" v-else>-->
<!--              <a class="nav-link login" @click="logout">Logout</a>-->
<!--            </li>-->
            <li class="nav-item" style="margin-left: 5px">
              <router-link to="/">Back</router-link>
            </li>
          </ul>
        </div>
      </nav>
    </div>
    <LoginModal/>
    <RegisterModal/>
  </header>
  <!-- End Header -->
</template>
<script>
import LoginModal from '@/components/LoginModal.vue';
import RegisterModal from '@/components/RegisterModal.vue';
import axios from "axios";
export default {
  name: "HeaderPayment",
  data() {
    return {
      localStatus: false
    }
  },
  components: {
    LoginModal,
    RegisterModal
  },
  computed: {
    loginStatus() {
      return this.$store.state.loginStatus
    },
  },
  created() {
    let accessToken = localStorage.getItem('access_token');
    if (accessToken != null && accessToken != "") {
      this.localStatus = true;
      this.$store.commit('loginStatus',true);
      this.getData(accessToken);
    } else {
      this.localStatus = false;
      this.$store.commit('loginStatus',false);
    }
  },
  methods: {
    logout() {
      localStorage.removeItem("access_token");
      this.$store.commit("loginStatus",false);
      this.$toaster.success('Logged out successfully.')
      window.location.href = '/';
    },
    openModal() {
      this.$store.commit('showModal',true);
    },
    getData(accessToken) {
      let instance = this;
      axios.get(`${this.apiPath}get-client-data/${accessToken}`).then(function (response){
        instance.$store.dispatch('setUser',response.data.data);
      }).catch(function (error){

      });
    }
  }
};
</script>

<style scoped lang="scss">
.become-partner {
  margin-right: 30px;
}
.nav-item a {
  font-size: 12px !important;
  font-weight: bold;
  color: #ffffff !important;
}

.nav-item .login {
  padding: 5px 15px;
  border-radius: 5px;
  color: #ffffff !important;
  background: #004a59;
  cursor: pointer;
  border: 1px solid #004a59;
}

.navbar-light .navbar-nav .login:hover {
  color: #FFFFFF !important;
}

.navbar-light .navbar-nav .login:focus {
  color: #FFFFFF !important;
}

@media (max-width: 768px) {
  #navbarSupportedContent {
    margin-top: 15px !important;
  }
  .login-logout {
    margin-bottom: 10px;
  }
}
</style>
